import { render, staticRenderFns } from "./pondTransfer.vue?vue&type=template&id=0f8c9f4b&scoped=true"
import script from "./pondTransfer.vue?vue&type=script&lang=js"
export * from "./pondTransfer.vue?vue&type=script&lang=js"
import style0 from "./pondTransfer.vue?vue&type=style&index=0&id=0f8c9f4b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8c9f4b",
  null
  
)

export default component.exports